import { useFeatureFlagCookieContext } from '@usap/core'

const useGetLifetimeReplacementFlag = () => {
  const cookieObject = useFeatureFlagCookieContext()
  const {
    lifetimeReplacement,
  } = { ...cookieObject }

  return lifetimeReplacement || 1
}

export default useGetLifetimeReplacementFlag
